import React from 'react';
import { useTranslation } from 'react-i18next';
import CommonTagsField from '../../../common/fields/TagsField';
import { OriginalDeviationFieldName } from '../../types';

interface Props {
  noBottomSpacing?: boolean;
}

const TagsField: React.FC<Props> = ({ noBottomSpacing }) => {
  const { t } = useTranslation();

  return (
    <CommonTagsField
      fieldName={OriginalDeviationFieldName.TAGS}
      label={t('originalDeviationPopup.form.tags.label')}
      placeholder={t('originalDeviationPopup.form.tags.placeholder')}
      noBottomSpacing={noBottomSpacing}
    />
  );
};
TagsField.displayName = 'TagsField';

export default TagsField;
